<template>
  <div class="shops">
    <div style="margin-bottom: 10px;">
      <el-text style="font-size: larger; font-weight: bolder;">
        {{ util.language('店铺（仓库）', 'Shop/Warehouse') }}
      </el-text>
    </div>
    <el-form :inline="true">
      <el-form-item>
        <el-button-group>
          <el-button type="primary" @click="commitFindList()" :loading="loading.find">{{ util.language('刷新', 'Refresh') }}</el-button>
        </el-button-group>
      </el-form-item>
      <el-form-item>
        <el-button-group>
          <el-button type="primary" @click="add()">{{ util.language('新增', 'New') }}</el-button>
          <el-button type="warning" :disabled="show.selected.length != 1" @click="update()">{{ util.language('详情', 'Detail') }}</el-button>
          <el-button type="danger" :disabled="show.selected.length < 1" @click="del()">{{ util.language('删除', 'Delete') }}</el-button>
        </el-button-group>
      </el-form-item>
    </el-form>
    <el-table :data="data.shopList" @selection-change="selectionChange()" ref="tabRef" border style="height: calc(100vh - 220px);" v-loading="loading.find">
      <el-table-column type="selection" width="55" align="center" />
      <el-table-column label="ID" width="70" align="center">
        <template #default="scope">
          <el-link type="primary" @click="update(scope.row)">{{ scope.row.id }}</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="code" :label="util.language('编号', 'Code')" width="100" show-overflow-tooltip />
      <el-table-column prop="enName" :label="util.language('英文名', 'English Name')" show-overflow-tooltip />
      <el-table-column prop="cnName" :label="util.language('中文名', 'Chinese Name')" width="200" show-overflow-tooltip />
      <el-table-column prop="phone" :label="util.language('电话号', 'Phone')" width="200" show-overflow-tooltip />
      <el-table-column prop="addressDetail" :label="util.language('地址', 'Address')" width="200" show-overflow-tooltip />
      <el-table-column :label="util.language('税率', 'Tax Rate')" width="200" show-overflow-tooltip>
        <template #default="scope">
          <span v-if="scope.row.hstRate">
            {{ 'HST:' + math.multiply(scope.row.hstRate, 100) + '% ' }}
          </span>
          <span v-if="scope.row.gstRate">
            {{ 'GST:' + math.multiply(scope.row.gstRate, 100) + '% ' }}
          </span>
          <span v-if="scope.row.pstRate">
            {{ 'PST:' + math.multiply(scope.row.pstRate, 100) + '% ' }}
          </span>
          <span v-if="scope.row.qstRate">
            {{ 'QST:' + math.multiply(scope.row.qstRate, 100) + '% ' }}
          </span>
          <span v-if="!scope.row.hstRate && !scope.row.gstRate && !scope.row.pstRate && !scope.row.qstRate">
            0%
          </span>
        </template>
      </el-table-column>
    </el-table>
    <div style="height: 10px;" />
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import api from '../../apis/api'
import cache from '../../utils/cache'
import util from '../../utils/util'
import math from '../../utils/math'

const router = useRouter()
const tabRef = ref()

const data = reactive({
  shopList: [],
})
const loading = reactive({
  find: false,
})
const show = reactive({
  selected: [],
})

const commitFindList = () => {
  loading.find = true
  api.get('/backend/shop/getShop').then(res => {
    data.shopList = res.list
  }).finally(() => {
    loading.find = false
  })
}
commitFindList()

const selectionChange = () => {
  show.selected = tabRef.value.getSelectionRows()
}

const add = () => {
  cache.setObject(cache.keys.pageParam + 'shop', null)
  router.push('/shop')
}

const del = () => {
  const shops = tabRef.value.getSelectionRows()
  const shopIdList = shops.map(shop => shop.id)
  ElMessageBox.confirm('', {
    title: util.language('确认删除', 'Confirm Delete'),
    message: util.language('将要删除 ' + shops.length + ' 个店铺。', 'Will delete ' + shops.length + ' shops.'),
    autofocus: false,
    confirmButtonText: util.language('删除', 'OK'),
    cancelButtonText: util.language('取消', 'Cancel'),
  }).then(() => {
    api.post('/backend/shop/delShop', { ids: shopIdList }).then(() => {
      ElMessage.success(util.language('删除成功', 'Success'))
      commitFindList()
    })
  })
}

const update = (row) => {
  const shop = row ? row : tabRef.value.getSelectionRows()[0]
  cache.setObject(cache.keys.pageParam + 'shop', shop)
  router.push('/shop')
}

</script>

<style lang="less"></style>